import FlagsIcon from "@components/FlagsIcon/FlagsIcon"
import SectionSubGroup from "@components/SectionGroup/SectionSubGroup"
import Localization from "@localization/Index"
import { useMobileMediaQuery } from "@utils/MediaComponents"
import { Customer } from "cs.node.utils/csapi/provisioning"
import { useNavigate } from "react-router-dom"

type Props = {
    customer: Customer
}

const HeaderSearchBarResultCustomer = (props: Props) => {
    const { customer } = props
    const navigate = useNavigate()
    const countryCode = customer?.billing_info?.address?.country_code
    const statusVariant = (customer.status === "ACTIVE")?"success":(customer.status === "INACTIVE")?"danger":"muted"
    const statusLabel = (customer.status === "ACTIVE")?Localization.PAGE_CUSTOMERS.STATUS.ACTIVE:(customer.status === "INACTIVE")?Localization.PAGE_CUSTOMERS.STATUS.INACTIVE:" - "
    const isMobile = useMobileMediaQuery()

    if(isMobile) {
        return <div className="row my-2 py-4 w-100" style={{borderBottom: '1px dashed var(--bs-gray-gray-300'}} onClick={(e)=>{
            const link = `/customers/${customer._id?.$oid}`
            
            if(e?.metaKey || e?.ctrlKey) {
                window.open(link, "_blank");
            } else{
                navigate(link)
            }
        }}>
            <div className="col-20 cs-link d-flex flex-column align-items-start justify-content-center">
                {(customer.first_name && customer.last_name)?`${customer.first_name} ${customer.last_name}`:customer.company_name}
                <div className="fw-bold small">{customer.security?.username?.trim() ?? '-'}</div>
                <div className="fw-normal small">{customer.customer_code ?? "-"}</div>
            </div>
            <div className="col-4 d-flex flex-column align-items-start justify-content-center">
                <span className={`badge fw-600 text-black bg-${statusVariant}-light`}>{statusLabel}</span>
            </div>
        </div>
    }

    return <SectionSubGroup small className="w-100" role="button" onClick={(e)=>{
            const link = `/customers/${customer._id?.$oid}`
            
            if(e?.metaKey || e?.ctrlKey) {
                window.open(link, "_blank");
            } else{
                navigate(link)
            }
        }}>
            <div className="row">
                <div className="col-8 cs-link d-flex align-items-center justify-content-start">
                    {(customer.first_name && customer.last_name)?`${customer.first_name} ${customer.last_name}`:customer.company_name}
                </div>
                <div className="col-8 d-flex flex-column align-items-start justify-content-center">
                    <div className="fw-bold small">{customer.security?.username?.trim() ?? '-'}</div>
                    <div className="fw-normal small">{customer.customer_code ?? "-"}</div>
                </div>
                <div className="col-4 d-flex align-items-center justify-content-start">
                    {countryCode && <div className="d-flex align-items-center">
                        <FlagsIcon flagId={countryCode.toLowerCase()} size={25} round={true} />
                        <span className="ms-2">{Localization.COUNTRIES_CODE[countryCode as keyof typeof Localization.COUNTRIES_CODE]}</span>
                    </div>}
                </div>
                <div className="col-4 d-flex align-items-center justify-content-center">
                    <span className={`badge fw-600 text-black bg-${statusVariant}-light`}>{statusLabel}</span>
                </div>
            </div>
        </SectionSubGroup>
}

export default HeaderSearchBarResultCustomer